// sticky cart component
class StickyAddCart extends HTMLElement {
constructor() {
    super();
    this.button_id = this.dataset.button;
    this.button_original = null;
    this.observer = null;
}
connectedCallback() {
    this.init();
}
init() {
    this.button_original = document.querySelector(this.button_id);
    if (!this.button_original) return;
    this.btn_item = this.querySelector('button.product-form__submit');
    this.btn_item.addEventListener('click', (e) =>{
    this.button_original.click();
    })
    this.createObserver();
}
createObserver() {
    this.observer = new IntersectionObserver(
    (entries) => {
        entries.forEach(entry => {
        if (!entry.isIntersecting) {
            this.classList.add('visible');
        } else {
            this.classList.remove('visible');
        }
        });
    },
    {
        root: null,
        threshold: 0
    }
    );
    this.observer.observe(this.button_original);
}
disconnectedCallback() {
    if (this.observer) {
    this.observer.disconnect();
    }
}
}
customElements.define('sticky-add-to-cart-custom', StickyAddCart);